import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useIdvSubmittedTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackIdvSubmitted = useCallback(
    (eventName: TrackingEvent) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
      });
    },
    [trackEvent],
  );

  const selectKycIdvProcessingWait = useCallback(
    (eventName: TrackingEvent) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
      });
    },
    [trackEvent],
  );

  const selectKycIdvProcessingNotifyMe = useCallback(
    (eventName: TrackingEvent) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.ONBOARDING,
      });
    },
    [trackEvent],
  );

  return {
    trackIdvSubmitted,
    selectKycIdvProcessingWait,
    selectKycIdvProcessingNotifyMe,
  };
};
